import React, { useEffect, useState, useRef } from "react";
import { globalFileServer } from '../../../axiosInstance';
import { useSelector, useDispatch } from 'react-redux';
import ProductAddToCart from "../routs/productPage/ProductAddToCart";
import ProductInfo from "../productInfo/ProductInfo";
import { CollectSiteProductRemoveProduct } from "../../server/CollectSite";
import { PriceDeliveryState, allPolygon } from '../../server/Polygon';
import { GetShippingAddress } from '../../server/ShippingAddress';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { productsInCart, productSale, openCart, user, role, deliveryPrice } = useSelector(state => ({
        productsInCart: state.productsInCart.productsInCart,
        productSale: state.productsInCart.productSale,
        openCart: state.openCart.openCart,
        user: state.user.user,
        role: state.user.role,
        deliveryPrice: state.productsInCart.deliveryPrice,
    }));

    const [addressList, setAddressList] = useState([]);
    const [polygonState, setPolygonState] = useState([]);
    const [cartTopPosition, setCartTopPosition] = useState(0);
    const cartRef = useRef(null);

    // Get header height and update cart position
    useEffect(() => {
        const updateCartPosition = () => {
            const header = document.querySelector('header') || document.getElementById('header');
            if (header) {
                const headerHeight = header.offsetHeight;
                setCartTopPosition(headerHeight);
            }
        };

        // Initial position
        updateCartPosition();

        // Update position when window resizes or when submenus might open/close
        window.addEventListener('resize', updateCartPosition);
        document.addEventListener('click', updateCartPosition);

        return () => {
            window.removeEventListener('resize', updateCartPosition);
            document.removeEventListener('click', updateCartPosition);
        };
    }, []);

    useEffect(() => {
        const fetchAddresses = async () => {
            if (user) {
                const addressResponse = await GetShippingAddress(user.Id);
                setAddressList(addressResponse.data);
                const response = await allPolygon();
                const polygons = response.data.map(item => item.polygon).flat();
                setPolygonState(polygons);
            }
        };

        fetchAddresses();
    }, [user]);

    useEffect(() => {
        if (addressList.length && polygonState.length) {
            const mainAddress = addressList.find(addr => addr.MainAddress);
            if (mainAddress) {
                dispatch(PriceDeliveryState(mainAddress.lat, mainAddress.lng, polygonState));
            }
        }
    }, [addressList, polygonState, dispatch]);

    return (
        <div 
            ref={cartRef}
            className={openCart && !role && user ? "header-cart opened" : "header-cart closed"}
            style={{ top: `${cartTopPosition}px` }}
        >
            <div className="header-cart-wrap">
                {/* Rest of the component remains the same */}
                <div className="products">
                    <table>
                        <tbody>
                            {productsInCart.length ? productsInCart.map(element => {
                                const saleItem = productSale.find(item => item.CollectSiteProductId === element.Id);
                                return (
                                    <tr className="item-mini-cart" key={element.Id}>
                                        <td className="img-item-td">
                                            <div className="img-item" style={element.PathUrl ? { backgroundImage: 'url(' + globalFileServer + 'products/' + element.PathUrl.split(",")[0] + ')' } : null} />
                                        </td>
                                        <td className="prod-info-and-name">
                                            <ProductInfo selectedProd={element} />
                                            {saleItem?.Text ? <p className="sale">במבצע!</p> : null}
                                            <div className="comment-warning">{element.CommentWarning}</div>
                                        </td>
                                        <td className="quantity">
                                            <ProductAddToCart element={element} haveInfo={false} />
                                        </td>
                                        <td className="price-details">
                                            <p className="price">{(element.Price * element.Quantity).toFixed(2)} <span>₪</span></p>
                                            {saleItem && saleItem.Price !== undefined && saleItem.QuantiyUse ? (
                                                <p className="sale">
                                                    {(saleItem.Price * saleItem.QuantiyUse).toFixed(2)} <span>- ₪</span>
                                                </p>
                                            ) : null}
                                        </td>
                                        <td className="delete-item">
                                            <button onClick={() => dispatch(CollectSiteProductRemoveProduct(element, -1))} className="delete-btn">
                                                <span className="delete-icon">✖</span>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            }) : null}
                            <tr className="delivery-price">
                                <td><p>מחיר משלוח:</p></td>
                                <td><p className="price">{deliveryPrice} <span>₪</span></p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MiniCart;